import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldWithDismiss = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15.7 8.46a1 1 0 0 0-1.4-1.42L12 9.34l-2.3-2.3a1 1 0 0 0-1.4 1.42l2.29 2.29-2.3 2.3a1 1 0 1 0 1.42 1.4L12 12.17l2.3 2.3a1 1 0 0 0 1.4-1.42l-2.29-2.29 2.3-2.3Z"
    />
    <path
      fill="currentColor"
      d="M11.5 21.88a1.1 1.1 0 0 0 1 0c.12-.07 2.96-1.63 4.38-2.85C18.89 17.3 21 14 21 11V4c0-.4-.25-.75-.65-.9C18.7 2.4 15 2 12 2s-6.7.4-8.35 1.1c-.4.15-.65.5-.65.9v7c0 3 1.69 5.93 4.3 8.13a34 34 0 0 0 4.2 2.75M5 4.74C6.5 4.3 9 4 12 4s5.5.3 7 .75V11c0 2.15-1.31 4.7-3.45 6.55-.9.77-2.7 1.97-3.55 2.45a31.5 31.5 0 0 1-3.45-2.45C6.44 15.75 5 13.15 5 11z"
    />
  </svg>
);
export default SvgShieldWithDismiss;
